import React from "react";
import './question.css';
import ContextData from './../../context/Data/ContextData';
import { useNavigate } from 'react-router-dom'; 
import Questions from '../../include/Questions/Questions'; 

const Question = () => {   
    const {stateData, dispatchData} = React.useContext(ContextData);
    let navigate = useNavigate();


 
  return ( 
    <> 
        <Questions/>
        <div className="question">
            <div className="question__content">
                <div className="question__top">
                    <div className="question__ava">?</div>
                    <div className="question__name" />
                </div>
                <div className="question__text" dangerouslySetInnerHTML={{ __html: stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].text }} />
            </div>
            <div className={"question__answers "+(stateData.contextQuestionsForUser[stateData.contextCurrentQuestion] === 1 ? 'question__answers--wide' : '')}>
                {stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].answers.map((el, i) => { 
                    return (
                        <button className="question__answer" type="button" onClick={()=>{ 
                            let answersArr = stateData.contextUserAnswers;
                            if(answersArr[stateData.contextCurrentQuestion] < 0){
                                answersArr[stateData.contextCurrentQuestion] = i;
                                window["ym"](88899563,'reachGoal', 'game_guess_who_ClickChannel', {screen: (stateData.contextCurrentQuestion+1), result: ((stateData.contextQuestions[stateData.contextQuestionsForUser[stateData.contextCurrentQuestion]].correct) === i ? 'угадал' :'не угадал') });
                                dispatchData({
                                  type: "FETCH_ANSWERS",
                                  payload: answersArr
                                }) 
                            }
                            return navigate("../answer", { replace: false }); 
                        }} key={'qa'+i} dangerouslySetInnerHTML={{ __html: el }} />
                    ); 
                })} 
            </div>
        </div>
    </>
  );
};

export default Question;
